// カテゴリのCRUD（CONTRACTS.md §3）

import { db } from './db';
import type { Category } from './types';

/** sortOrder順のカテゴリ一覧 */
export async function listCategories(): Promise<Category[]> {
  return db.categories.orderBy('sortOrder').toArray();
}

export async function addCategory(name: string): Promise<Category> {
  const existing = await db.categories.orderBy('sortOrder').last();
  const nextSortOrder = existing ? existing.sortOrder + 1 : 0;
  const category: Category = {
    id: crypto.randomUUID(),
    name,
    sortOrder: nextSortOrder,
    createdAt: new Date().toISOString(),
  };
  await db.categories.put(category);
  return category;
}

export async function renameCategory(id: string, name: string): Promise<void> {
  await db.categories.update(id, { name });
}

/** そのカテゴリを参照している支出記録が1件でもあるか */
export async function isCategoryInUse(id: string): Promise<boolean> {
  const count = await db.expenses.where('categoryId').equals(id).count();
  return count > 0;
}

/**
 * カテゴリを削除する。使用中（支出記録が存在する）場合は削除せず reason: 'in-use' を返す。
 * 削除が成功した場合、そのカテゴリに紐づく予算レコードも合わせて削除する。
 */
export async function deleteCategory(
  id: string
): Promise<{ ok: true } | { ok: false; reason: 'in-use' }> {
  if (await isCategoryInUse(id)) {
    return { ok: false, reason: 'in-use' };
  }
  await db.transaction('rw', db.categories, db.budgets, async () => {
    await db.categories.delete(id);
    await db.budgets.where('categoryId').equals(id).delete();
  });
  return { ok: true };
}
